export enum AuthenticationMethod {
   Samwin = 1,
   Domain = 2,
   MicrosoftEntraId = 3,
}
